import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";

export const ContactUsSubmitApi = createAsyncThunk(
  "ContactUsSlice/ContactUsSubmitApi",
  async (formData) => {
    try {
      const { data: response } = await axios.post(
        baseUrl + "contactUsSubmit",
        formData
      );

      if (response.status === "success") {
        return { data: response.data, message: response.message };
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      console.error("Contact Us API Error", error);
      throw error;
    }
  }
);
